var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('InnerScroll',{attrs:{"title":_vm.sent
      ? _vm.$t('system.feedback.submit.successHead')
      : _vm.$t('system.navigation.feedback'),"loading":_vm.loading}},[_c('FeedbackForm',{attrs:{"loading":_vm.loading,"entry-text":_vm.entryText,"form-fields":_vm.formFields,"sent":_vm.sent},on:{"update:sent":function($event){_vm.sent=$event}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }